const BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? "";

export class ApiError extends Error {
  constructor(public status: number, public body: unknown) {
    super(`api error ${status}`);
  }
}

function token(): string | null {
  return localStorage.getItem("atelier.jwt");
}

async function request<T>(method: string, path: string, body?: unknown, opts: { auth?: boolean; raw?: boolean } = {}): Promise<T> {
  const url = `${BASE}${path}`;
  const headers: Record<string, string> = {};
  if (body !== undefined && !(body instanceof FormData)) headers["content-type"] = "application/json";
  if (opts.auth) {
    const t = token();
    if (!t) throw new ApiError(401, { error: "not authenticated" });
    headers["authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(url, {
    method,
    headers,
    body:
      body === undefined
        ? null
        : body instanceof FormData
          ? body
          : JSON.stringify(body),
  });
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new ApiError(res.status, payload);
  }
  if (opts.raw) return (await res.text()) as unknown as T;
  return (await res.json()) as T;
}

export const api = {
  get: <T,>(p: string, opts?: { auth?: boolean }) => request<T>("GET", p, undefined, opts),
  post: <T,>(p: string, body?: unknown, opts?: { auth?: boolean }) => request<T>("POST", p, body, opts),
  patch: <T,>(p: string, body?: unknown, opts?: { auth?: boolean }) => request<T>("PATCH", p, body, opts),
  del: <T = { ok: true },>(p: string, opts?: { auth?: boolean }) => request<T>("DELETE", p, undefined, opts),
  uploadFile: async (file: File): Promise<{ cid: string }> => {
    const fd = new FormData();
    fd.append("file", file);
    return request<{ cid: string }>("POST", "/ipfs/upload", fd, { auth: true });
  },
  uploadJson: (json: unknown) => request<{ cid: string }>("POST", "/ipfs/json", json, { auth: true }),
};

export function setJwt(t: string) {
  localStorage.setItem("atelier.jwt", t);
}
export function clearJwt() {
  localStorage.removeItem("atelier.jwt");
}
export function getJwt() {
  return token();
}
